import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './SuperAdminSidebar.css';

const ASSET_BASE_PATH = `${process.env.PUBLIC_URL}`;

const Sidebar = () => {
    const location = useLocation();
    const [openMenu, setOpenMenu] = useState('');

    useEffect(() => {
        // Auto expand menu based on path
        if (location.pathname.includes('/superadmin/vendors')) {
            setOpenMenu('vendors');
        } else if (location.pathname.includes('/superadmin/listings-approval')) {
            if (location.pathname.includes('doctors') || location.pathname.includes('hospitals')) {
                setOpenMenu('medical-tourism');
            } else {
                setOpenMenu('listings');
            }
        } else if (location.pathname.includes('/superadmin/web-pages')) {
            setOpenMenu('webpages');
        } else if (location.pathname.includes('/superadmin/settings')) {
            setOpenMenu('settings');
        } else {
            setOpenMenu('');
        }
    }, [location.pathname]);

    const toggleMenu = (menuName) => {
        setOpenMenu(openMenu === menuName ? '' : menuName);
    };

    const toggleSidebar = () => {
        const currentSize = document.documentElement.getAttribute('data-sidebar-size');
        if (currentSize === 'sm') {
            document.documentElement.setAttribute('data-sidebar-size', 'lg');
        } else {
            document.documentElement.setAttribute('data-sidebar-size', 'sm');
        }
    };

    const closeSidebar = () => {
        if (document.body.classList.contains("vertical-sidebar-enable")) {
            document.body.classList.remove("vertical-sidebar-enable");
        }
    };

    const isActive = (path) => location.pathname === path;
    const isVendorsActive = location.pathname.includes('/superadmin/vendors');

    return (
        <div className="app-menu navbar-menu">
            <div className="navbar-brand-box">
                <Link to="/superadmin/dashboard" className="logo logo-dark">
                    <span className="logo-sm">
                        <img src={`${ASSET_BASE_PATH}/logo-mangoloops.png`} alt="" height="22" />
                    </span>
                    <span className="logo-lg">
                        <img src={`${ASSET_BASE_PATH}/logo-mangoloops.png`} alt="" height="17" />
                    </span>
                </Link>
                <Link to="/superadmin/dashboard" className="logo logo-light">
                    <span className="logo-sm">
                        <img src={`${ASSET_BASE_PATH}/logo-mangoloops.png`} alt="" height="22" />
                    </span>
                    <span className="logo-lg">
                        <img src={`${ASSET_BASE_PATH}/logo-mangoloops.png`} alt="" height="17" />
                    </span>
                </Link>
                <button
                    type="button"
                    className="btn btn-sm p-0 fs-20 header-item float-end btn-vertical-sm-hover"
                    id="vertical-hover"
                    onClick={toggleSidebar}
                >
                    <i className="ri-record-circle-line"></i>
                </button>
                <button
                    type="button"
                    className="btn btn-sm p-0 fs-20 header-item float-end d-none-desktop"
                    id="sidebar-close-btn"
                    onClick={closeSidebar}
                    style={{ display: 'none' }}
                >
                    <i className="ri-close-line fs-24"></i>
                </button>
            </div>

            <div id="scrollbar">
                <div className="container-fluid">
                    <ul className="navbar-nav" id="navbar-nav">
                        <li className="menu-title"><span data-key="t-menu">Menu</span></li>

                        <li className="nav-item">
                            <Link
                                to="/superadmin/dashboard"
                                className={`nav-link menu-link ${isActive('/superadmin/dashboard') ? 'active' : ''}`}
                                onClick={closeSidebar}
                            >
                                <i className="mdi mdi-speedometer"></i> <span data-key="t-dashboards">Dashboard</span>
                            </Link>
                        </li>

                        <li className="nav-item">
                            <a
                                className={`nav-link menu-link ${openMenu !== 'vendors' ? 'collapsed' : ''} ${isVendorsActive ? 'active' : ''}`}
                                href="#sidebarVendors"
                                onClick={(e) => { e.preventDefault(); toggleMenu('vendors'); }}
                                aria-expanded={openMenu === 'vendors'}
                                aria-controls="sidebarVendors"
                            >
                                <i className="mdi mdi-account-group"></i> <span data-key="t-vendors">Vendors</span>
                            </a>
                            <div className={`collapse menu-dropdown ${openMenu === 'vendors' ? 'show' : ''}`} id="sidebarVendors">
                                <ul className="nav nav-sm flex-column">
                                    <li className="nav-item">
                                        <Link
                                            to="/superadmin/vendors/paid"
                                            className={`nav-link ${isActive('/superadmin/vendors/paid') ? 'active' : ''}`}
                                            onClick={closeSidebar}
                                        > Paid </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link
                                            to="/superadmin/vendors/free"
                                            className={`nav-link ${isActive('/superadmin/vendors/free') ? 'active' : ''}`}
                                            onClick={closeSidebar}
                                        > Free </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link
                                            to="/superadmin/vendors/trial"
                                            className={`nav-link ${isActive('/superadmin/vendors/trial') ? 'active' : ''}`}
                                            onClick={closeSidebar}
                                        > Trial </Link>
                                    </li>
                                </ul>
                            </div>
                        </li>

                        <li className="nav-item">
                            <Link
                                to="/superadmin/leads"
                                className={`nav-link menu-link ${isActive('/superadmin/leads') ? 'active' : ''}`}
                                onClick={closeSidebar}
                            >
                                <i className="mdi mdi-account-convert"></i> <span data-key="t-leads">Lead Management</span>
                            </Link>
                        </li>

                        <li className="nav-item">
                            <Link
                                to="/superadmin/registered-customers"
                                className={`nav-link menu-link ${isActive('/superadmin/registered-customers') ? 'active' : ''}`}
                                onClick={closeSidebar}
                            >
                                <i className="mdi mdi-account-multiple"></i> <span data-key="t-customers">Registered Customers</span>
                            </Link>
                        </li>
                        <li className="nav-item">
                            <a
                                className={`nav-link menu-link ${openMenu !== 'listings' && openMenu !== 'medical-tourism' ? 'collapsed' : ''} ${location.pathname.includes('/superadmin/listings-approval') ? 'active' : ''}`}
                                href="#sidebarListings"
                                onClick={(e) => { e.preventDefault(); toggleMenu('listings'); }}
                                aria-expanded={openMenu === 'listings' || openMenu === 'medical-tourism'}
                                aria-controls="sidebarListings"
                            >
                                <i className="mdi mdi-format-list-checks"></i> <span data-key="t-listings">Listing Approval</span>
                            </a>
                            <div className={`collapse menu-dropdown ${openMenu === 'listings' || openMenu === 'medical-tourism' || location.pathname.includes('/superadmin/listings-approval') ? 'show' : ''}`} id="sidebarListings">
                                <ul className="nav nav-sm flex-column">
                                    <li className="nav-item">
                                        <Link
                                            to="/superadmin/listings-approval/holidays"
                                            className={`nav-link ${isActive('/superadmin/listings-approval/holidays') ? 'active' : ''}`}
                                            onClick={closeSidebar}
                                        > Holidays </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link
                                            to="/superadmin/listings-approval/hotels"
                                            className={`nav-link ${isActive('/superadmin/listings-approval/hotels') ? 'active' : ''}`}
                                            onClick={closeSidebar}
                                        > Hotels </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link
                                            to="/superadmin/listings-approval/cabs"
                                            className={`nav-link ${isActive('/superadmin/listings-approval/cabs') ? 'active' : ''}`}
                                            onClick={closeSidebar}
                                        > Cabs </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link
                                            to="/superadmin/listings-approval/yatras"
                                            className={`nav-link ${isActive('/superadmin/listings-approval/yatras') ? 'active' : ''}`}
                                            onClick={closeSidebar}
                                        > Yatras </Link>
                                    </li>
                                    <li className="nav-item">
                                        <a
                                            className={`nav-link ${openMenu !== 'medical-tourism' ? 'collapsed' : ''} ${location.pathname.includes('/superadmin/listings-approval/doctors') || location.pathname.includes('/superadmin/listings-approval/hospitals') ? 'active' : ''}`}
                                            href="#sidebarMedicalTourism"
                                            onClick={(e) => { e.preventDefault(); toggleMenu('medical-tourism'); }}
                                            aria-expanded={openMenu === 'medical-tourism'}
                                            aria-controls="sidebarMedicalTourism"
                                        >
                                            Medical Tourism
                                        </a>
                                        <div className={`collapse menu-dropdown ${openMenu === 'medical-tourism' || location.pathname.includes('/superadmin/listings-approval/doctors') || location.pathname.includes('/superadmin/listings-approval/hospitals') ? 'show' : ''}`} id="sidebarMedicalTourism">
                                            <ul className="nav nav-sm flex-column">
                                                <li className="nav-item">
                                                    <Link
                                                        to="/superadmin/listings-approval/doctors"
                                                        className={`nav-link ${isActive('/superadmin/listings-approval/doctors') ? 'active' : ''}`}
                                                        onClick={closeSidebar}
                                                    > Doctors </Link>
                                                </li>
                                                <li className="nav-item">
                                                    <Link
                                                        to="/superadmin/listings-approval/hospitals"
                                                        className={`nav-link ${isActive('/superadmin/listings-approval/hospitals') ? 'active' : ''}`}
                                                        onClick={closeSidebar}
                                                    > Hospitals </Link>
                                                </li>
                                            </ul>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </li>

                        <li className="nav-item">
                            <Link
                                to="/superadmin/blogs"
                                className={`nav-link menu-link ${location.pathname.startsWith('/superadmin/blogs') ? 'active' : ''}`}
                                onClick={closeSidebar}
                            >
                                <i className="mdi mdi-book-open-page-variant"></i> <span data-key="t-blogs">Blog Management</span>
                            </Link>
                        </li>

                        <li className="nav-item">
                            <a
                                className={`nav-link menu-link ${openMenu !== 'webpages' ? 'collapsed' : ''} ${location.pathname.includes('/superadmin/web-pages') || location.pathname.includes('/superadmin/settings/meta-tags') ? 'active' : ''}`}
                                href="#sidebarWebPages"
                                onClick={(e) => { e.preventDefault(); toggleMenu('webpages'); }}
                                aria-expanded={openMenu === 'webpages'}
                                aria-controls="sidebarWebPages"
                            >
                                <i className="mdi mdi-web"></i> <span data-key="t-webpages">Web Pages</span>
                            </a>
                            <div className={`collapse menu-dropdown ${openMenu === 'webpages' || location.pathname.includes('/superadmin/settings/meta-tags') ? 'show' : ''}`} id="sidebarWebPages">
                                <ul className="nav nav-sm flex-column">
                                    <li className="nav-item">
                                        <Link
                                            to="/superadmin/web-pages/header-pages"
                                            className={`nav-link ${location.pathname.includes('/superadmin/web-pages/header-pages') ? 'active' : ''}`}
                                            onClick={closeSidebar}
                                        > Main Pages </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link
                                            to="/superadmin/web-pages/information"
                                            className={`nav-link ${isActive('/superadmin/web-pages/information') ? 'active' : ''}`}
                                            onClick={closeSidebar}
                                        > Information Pages </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link
                                            to="/superadmin/web-pages/other"
                                            className={`nav-link ${isActive('/superadmin/web-pages/other') ? 'active' : ''}`}
                                            onClick={closeSidebar}
                                        > Other Pages </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link
                                            to="/superadmin/settings/meta-tags"
                                            className={`nav-link ${isActive('/superadmin/settings/meta-tags') ? 'active' : ''}`}
                                            onClick={closeSidebar}
                                        > Header / Footer Links </Link>
                                    </li>
                                </ul>
                            </div>
                        </li>

                        <li className="menu-title"><span data-key="t-subscription">Subscription</span></li>

                        <li className="nav-item">
                            <Link
                                to="/superadmin/plans"
                                className={`nav-link menu-link ${isActive('/superadmin/plans') ? 'active' : ''}`}
                                onClick={closeSidebar}
                            >
                                <i className="mdi mdi-card-bulleted-outline"></i> <span data-key="t-plans">Plans</span>
                            </Link>
                        </li>

                        <li className="nav-item">
                            <a
                                className={`nav-link menu-link ${openMenu !== 'settings' ? 'collapsed' : ''} ${location.pathname.includes('/superadmin/settings') && location.pathname !== '/superadmin/settings/meta-tags' ? 'active' : ''}`}
                                href="#sidebarSettings"
                                onClick={(e) => { e.preventDefault(); toggleMenu('settings'); }}
                                aria-expanded={openMenu === 'settings'}
                                aria-controls="sidebarSettings"
                            >
                                <i className="mdi mdi-cog-outline"></i> <span data-key="t-settings">Settings</span>
                            </a>
                            <div className={`collapse menu-dropdown ${openMenu === 'settings' && location.pathname !== '/superadmin/settings/meta-tags' ? 'show' : ''}`} id="sidebarSettings">
                                <ul className="nav nav-sm flex-column">
                                    <li className="nav-item">
                                        <Link
                                            to="/superadmin/settings/subscription"
                                            className={`nav-link ${isActive('/superadmin/settings/subscription') ? 'active' : ''}`}
                                            onClick={closeSidebar}
                                        > Subscription Settings </Link>
                                    </li>
                                </ul>
                            </div>
                        </li>
                        
                        <li className="nav-item">
                            <Link
                                to="/superadmin/trash/vendors"
                                className={`nav-link menu-link ${location.pathname.includes('/superadmin/trash') ? 'active' : ''}`}
                                onClick={closeSidebar}
                            >
                                <i className="mdi mdi-delete-sweep-outline"></i> <span data-key="t-trash">Trash</span>
                            </Link>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="sidebar-background"></div>
        </div>
    );
};

export default Sidebar;
